import React, { FC, memo } from 'react';
import { WarehouseForBooking } from 'entities/Warehouse';
import { Box } from 'entities/Box';
import { ContractInfo } from 'entities/Contract';
import { ModernWarehouseInfoCard } from './ModernWarehouseInfoCard';
import { ModernSelectedBoxInfoCard } from './ModernSelectedBoxInfoCard';
import { ModernPriceDetailsCard } from './ModernPriceDetailsCard';
import { ModernTotalToPayCard } from './ModernTotalToPayCard';

interface ModernSummaryListProps {
  warehouseInfo: Nullable<WarehouseForBooking>;
  boxInfo: Nullable<Box>;
  contractOptions: ContractInfo;
}

export const ModernSummaryList: FC<ModernSummaryListProps> = memo((props) => {
  const { warehouseInfo, boxInfo, contractOptions } = props;

  return (
    <div className="space-y-1">
      {warehouseInfo && <ModernWarehouseInfoCard warehouseInfo={warehouseInfo} />}

      {boxInfo && warehouseInfo && (
        <ModernSelectedBoxInfoCard boxInfo={boxInfo} warehouseInfo={warehouseInfo} accountType={contractOptions.accountType} />
      )}

      {boxInfo && <ModernPriceDetailsCard contractInfo={contractOptions} />}

      {boxInfo && <ModernTotalToPayCard contractInfo={contractOptions} />}
    </div>
  );
});
